import { render, staticRenderFns } from "./InterfaceGroupSort.vue?vue&type=template&id=4f56db25"
import script from "./InterfaceGroupSort.vue?vue&type=script&lang=js"
export * from "./InterfaceGroupSort.vue?vue&type=script&lang=js"
import style0 from "./InterfaceGroupSort.vue?vue&type=style&index=0&id=4f56db25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports